// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"wrap-sgmOfhSs clearfix"};